import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-info",
  templateUrl: "./med-icon-info.component.html",
})
export class MedIconInfoComponent extends SvgMixinComponent {}
